//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UsersClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetAllUsersUsersQueryParameters = {
  ids?: string[] | null | null;
  searchQuery?: string | null | null;
  roles?: string[] | null | null;
  generalRoles?: string[] | null | null;
  withoutStudy?: boolean | null | null;
  predefinedUser?: boolean | null | null;
  studyIds?: number[] | null | null;
  permissions?: Types.Permissions[] | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

    
export function getAllUsersUrl(ids?: string[] | null | undefined, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, generalRoles?: string[] | null | undefined, withoutStudy?: boolean | null | undefined, predefinedUser?: boolean | null | undefined, studyIds?: number[] | null | undefined, permissions?: Types.Permissions[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/users?";
if (ids !== undefined && ids !== null)
    ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (roles !== undefined && roles !== null)
    roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
if (generalRoles !== undefined && generalRoles !== null)
    generalRoles && generalRoles.forEach(item => { url_ += "GeneralRoles=" + encodeURIComponent("" + item) + "&"; });
if (withoutStudy !== undefined && withoutStudy !== null)
    url_ += "WithoutStudy=" + encodeURIComponent("" + withoutStudy) + "&";
if (predefinedUser !== undefined && predefinedUser !== null)
    url_ += "PredefinedUser=" + encodeURIComponent("" + predefinedUser) + "&";
if (studyIds !== undefined && studyIds !== null)
    studyIds && studyIds.forEach(item => { url_ += "StudyIds=" + encodeURIComponent("" + item) + "&"; });
if (permissions !== undefined && permissions !== null)
    permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllUsersDefaultOptions: UseQueryOptions<Types.PagedResultOfStaffDto, unknown, Types.PagedResultOfStaffDto> = {
  queryFn: __getAllUsers,
};
export function getGetAllUsersDefaultOptions(): UseQueryOptions<Types.PagedResultOfStaffDto, unknown, Types.PagedResultOfStaffDto> {
  return getAllUsersDefaultOptions;
};
export function setGetAllUsersDefaultOptions(options: UseQueryOptions<Types.PagedResultOfStaffDto, unknown, Types.PagedResultOfStaffDto>) {
  getAllUsersDefaultOptions = options;
}

export function getAllUsersQueryKey(dto: GetAllUsersUsersQueryParameters): QueryKey;
export function getAllUsersQueryKey(ids?: string[] | null | undefined, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, generalRoles?: string[] | null | undefined, withoutStudy?: boolean | null | undefined, predefinedUser?: boolean | null | undefined, studyIds?: number[] | null | undefined, permissions?: Types.Permissions[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getAllUsersQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { ids, searchQuery, roles, generalRoles, withoutStudy, predefinedUser, studyIds, permissions, offset, limit, sortBy, sortOrder,  } = params[0] as GetAllUsersUsersQueryParameters;

    return trimArrayEnd([
        'UsersClient',
        'getAllUsers',
        ids as any,
        searchQuery as any,
        roles as any,
        generalRoles as any,
        withoutStudy as any,
        predefinedUser as any,
        studyIds as any,
        permissions as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'UsersClient',
        'getAllUsers',
        ...params
      ]);
  }
}
function __getAllUsers(context: QueryFunctionContext) {
  return Client.getAllUsers(
      context.queryKey[2] as string[] | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as boolean | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as number[] | null | undefined,       context.queryKey[9] as Types.Permissions[] | null | undefined,       context.queryKey[10] as number | null | undefined,       context.queryKey[11] as number | null | undefined,       context.queryKey[12] as string | null | undefined,       context.queryKey[13] as Types.SortOrder | undefined    );
}

export function useGetAllUsersQuery<TSelectData = Types.PagedResultOfStaffDto, TError = unknown>(dto: GetAllUsersUsersQueryParameters, options?: UseQueryOptions<Types.PagedResultOfStaffDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns list of all users (without patients).
 * @param ids (optional) Ids of users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) Filter for roles.
 * @param generalRoles (optional) Filter for general roles.
 * @param withoutStudy (optional) Filter for users who is not in any study.
 * @param predefinedUser (optional) Filter for users who was created manually for external auth.
 * @param studyIds (optional) List of study where users are present.
If "WithoutStudy" filter is ENABLED this filter will be ignored!
 * @param permissions (optional) List of permissions
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetAllUsersQuery<TSelectData = Types.PagedResultOfStaffDto, TError = unknown>(ids?: string[] | null | undefined, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, generalRoles?: string[] | null | undefined, withoutStudy?: boolean | null | undefined, predefinedUser?: boolean | null | undefined, studyIds?: number[] | null | undefined, permissions?: Types.Permissions[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfStaffDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllUsersQuery<TSelectData = Types.PagedResultOfStaffDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfStaffDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let ids: any = undefined;
  let searchQuery: any = undefined;
  let roles: any = undefined;
  let generalRoles: any = undefined;
  let withoutStudy: any = undefined;
  let predefinedUser: any = undefined;
  let studyIds: any = undefined;
  let permissions: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ ids, searchQuery, roles, generalRoles, withoutStudy, predefinedUser, studyIds, permissions, offset, limit, sortBy, sortOrder,  } = params[0] as GetAllUsersUsersQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [ids, searchQuery, roles, generalRoles, withoutStudy, predefinedUser, studyIds, permissions, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfStaffDto, TError, TSelectData>({
    queryFn: __getAllUsers,
    queryKey: getAllUsersQueryKey(ids, searchQuery, roles, generalRoles, withoutStudy, predefinedUser, studyIds, permissions, offset, limit, sortBy, sortOrder),
    ...getAllUsersDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfStaffDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns list of all users (without patients).
 * @param ids (optional) Ids of users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) Filter for roles.
 * @param generalRoles (optional) Filter for general roles.
 * @param withoutStudy (optional) Filter for users who is not in any study.
 * @param predefinedUser (optional) Filter for users who was created manually for external auth.
 * @param studyIds (optional) List of study where users are present.
If "WithoutStudy" filter is ENABLED this filter will be ignored!
 * @param permissions (optional) List of permissions
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetAllUsersData(queryClient: QueryClient, updater: (data: Types.PagedResultOfStaffDto | undefined) => Types.PagedResultOfStaffDto, ids?: string[] | null | undefined, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, generalRoles?: string[] | null | undefined, withoutStudy?: boolean | null | undefined, predefinedUser?: boolean | null | undefined, studyIds?: number[] | null | undefined, permissions?: Types.Permissions[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getAllUsersQueryKey(ids, searchQuery, roles, generalRoles, withoutStudy, predefinedUser, studyIds, permissions, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Returns list of all users (without patients).
 * @param ids (optional) Ids of users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) Filter for roles.
 * @param generalRoles (optional) Filter for general roles.
 * @param withoutStudy (optional) Filter for users who is not in any study.
 * @param predefinedUser (optional) Filter for users who was created manually for external auth.
 * @param studyIds (optional) List of study where users are present.
If "WithoutStudy" filter is ENABLED this filter will be ignored!
 * @param permissions (optional) List of permissions
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetAllUsersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfStaffDto | undefined) => Types.PagedResultOfStaffDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createUserUrl(): string {
  let url_ = getBaseUrl() + "/api/users";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createUserMutationKey(): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'createUser',
    ]);
}

/**
 * Creates user with predefined email for further log in and assignment for study.
 * @param dto user information DTO.
 */
export function useCreateUserMutation<TContext>(options?: Omit<UseMutationOptions<Types.StaffDto, unknown, Types.CreatePredefinedUserDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StaffDto, unknown, Types.CreatePredefinedUserDto, TContext> {
  const key = createUserMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreatePredefinedUserDto) => Client.createUser(dto), {...options, mutationKey: key});
}
  
    
export function createUsersUrl(): string {
  let url_ = getBaseUrl() + "/api/users/batch";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createUsersMutationKey(): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'createUsers',
    ]);
}

/**
 * Creates user with predefined email for further log in and assignment for study.
 * @param data List of users with their information DTO.
 */
export function useCreateUsersMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.CreatePredefinedUserDto[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CreatePredefinedUserDto[], TContext> {
  const key = createUsersMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((data: Types.CreatePredefinedUserDto[]) => Client.createUsers(data), {...options, mutationKey: key});
}
  
    
export function changeUserGeneralRolesUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}/Roles";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function changeUserGeneralRolesMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'changeUserGeneralRoles',
      id as any,
    ]);
}

/**
 * Change Identity roles of user by Id.
All not provided roles - will be removed from user store.
 * @param id Id of the user.
 * @param roles List with new Identity roles.
 */
export function useChangeUserGeneralRolesMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.StaffDto, unknown, string[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StaffDto, unknown, string[], TContext> {
  const key = changeUserGeneralRolesMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((roles: string[]) => Client.changeUserGeneralRoles(id, roles), {...options, mutationKey: key});
}
  
    
export function changeUserStudyRolesUrl(id: string, studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/users/{id}/StudyRoles?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function changeUserStudyRolesMutationKey(id: string, studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'changeUserStudyRoles',
      id as any,
      studyId as any,
    ]);
}

/**
 * Change Study roles of user by Id.
All not provided roles - will be removed from user store.
 * @param id Id of the user.
 * @param roleIds List with new Study roles.
 * @param studyId (optional) Id of the user.
 */
export function useChangeUserStudyRolesMutation<TContext>(id: string, studyId?: number | undefined, options?: Omit<UseMutationOptions<Types.StaffDto, unknown, string[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StaffDto, unknown, string[], TContext> {
  const key = changeUserStudyRolesMutationKey(id, studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((roleIds: string[]) => Client.changeUserStudyRoles(id, roleIds, studyId), {...options, mutationKey: key});
}
  
    
export function changeUserTagFiltersUrl(id: string, studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/users/{id}/TagFilters?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function changeUserTagFiltersMutationKey(id: string, studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'changeUserTagFilters',
      id as any,
      studyId as any,
    ]);
}

/**
 * Change tag filters of the user with the specified id
 * @param id The id of the user to update
 * @param studyId (optional) 
 * @param tagFilters (optional) New tag filters
 */
export function useChangeUserTagFiltersMutation<TContext>(id: string, studyId?: number | undefined, options?: Omit<UseMutationOptions<Types.StaffDto, unknown, { [key: string]: string[]; }, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StaffDto, unknown, { [key: string]: string[]; }, TContext> {
  const key = changeUserTagFiltersMutationKey(id, studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((tagFilters: { [key: string]: string[]; }) => Client.changeUserTagFilters(id, studyId, tagFilters), {...options, mutationKey: key});
}
  
    
export function assignToStudyUrl(id: string, studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/users/{id}/assign?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function assignToStudyMutationKey(id: string, studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'assignToStudy',
      id as any,
      studyId as any,
    ]);
}

/**
 * Assign doctor to the specific study.
 * @param id Id of teh doctor.
 * @param studyId (optional) Study Id that user will be assigned.
 */
export function useAssignToStudyMutation<TContext>(id: string, studyId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = assignToStudyMutationKey(id, studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.assignToStudy(id, studyId), {...options, mutationKey: key});
}
  
    
export function unassignStudyUrl(id: string, studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/users/{id}/unassign?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function unassignStudyMutationKey(id: string, studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'unassignStudy',
      id as any,
      studyId as any,
    ]);
}

/**
 * Unassign study for a doctor
 * @param id Id of teh doctor.
 * @param studyId (optional) Study Id that will be unassigned.
 */
export function useUnassignStudyMutation<TContext>(id: string, studyId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = unassignStudyMutationKey(id, studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.unassignStudy(id, studyId), {...options, mutationKey: key});
}
  
    
export function patchUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'patchUser',
      id as any,
    ]);
}

export function usePatchUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.StaffDto, unknown, Types.PatchUserDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StaffDto, unknown, Types.PatchUserDto, TContext> {
  const key = patchUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.PatchUserDto) => Client.patchUser(id, dto), {...options, mutationKey: key});
}
  
    
export function deleteUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UsersClient',
      'deleteUser',
      id as any,
    ]);
}

export function useDeleteUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.deleteUser(id), {...options, mutationKey: key});
}